import { Container, Row, Col } from "react-bootstrap";
import achievementsData from "../data/achievements.json";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Achievements = () => {
  return (
    <section className="achievements" id="achievements">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Achievements</h2>
                  <ul className="achievements-list">
                    {achievementsData.map((item) => (
                      <li key={item.title} className="achievement-item">
                        <span className="achievement-title">{item.title}:</span>{" "}
                        <span className="achievement-desc">{item.description}</span>{" "}
                        <span className="achievement-year">({item.year})</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
